import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Grid, Typography } from '@mui/material';
import i18next from 'i18next';

import useTypedSelector from 'hooks/useTypedSelector';
import { contactSettingsSelector } from 'redux/selectors/contactSettings.selector';
import { sendContactEmailRequest, resetContactStatus } from 'redux/actions/contactSettings.actions';

import ContactView from 'views/public/ContactView';
import Loading from 'components/commons/Loading';

import { IContactFormData } from '../ContactView/types';
import {
  StyledLandingContainer,
  HeroSection,
  HeroTitle,
  HeroSubtitle,
  SectionTitle,
  ContactWrapper,
} from './styles';
import './i18n';

const LandingPage: React.FC = () => {
  const dispatch = useDispatch();
  const { loading, success } = useTypedSelector(contactSettingsSelector);

  useEffect(() => {
    return () => {
      dispatch(resetContactStatus());
    };
  }, [dispatch]);

  const onSubmit = (formData: IContactFormData) => dispatch(sendContactEmailRequest(formData));

  return (
    <StyledLandingContainer maxWidth="lg">
      <HeroSection sx={{ textAlign: 'center', py: 8 }}>
        <HeroTitle variant="h1" sx={{ fontWeight: 800, letterSpacing: '-0.02em', mb: 2 }}>
          {i18next.t<string>('LANDING_PAGE:HERO_TITLE')}
        </HeroTitle>
        <HeroSubtitle
          variant="h5"
          sx={{ color: '#FFFFFF', fontWeight: 300, maxWidth: '800px', mx: 'auto' }}
        >
          {i18next.t<string>('LANDING_PAGE:HERO_SUBTITLE')}
        </HeroSubtitle>
      </HeroSection>
      <Grid container spacing={6} justifyContent="center">
        <Grid item xs={12} md={10} lg={8}>
          <ContactWrapper
            sx={{
              p: { xs: 4, md: 8 },
              borderRadius: '24px',
              boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
            }}
          >
            <SectionTitle variant="h3" sx={{ fontWeight: 700, mb: 1 }}>
              {i18next.t<string>('LANDING_PAGE:CONTACT_TITLE')}
            </SectionTitle>
            <Typography variant="body1" sx={{ mb: 5, color: '#000', opacity: 0.8 }}>
              {i18next.t<string>('LANDING_PAGE:CONTACT_SUBTITLE')}
            </Typography>
            <ContactView onSubmit={onSubmit} success={success} fullWidth />
            {loading && <Loading isModalMode message={i18next.t('CONTACT:LOADING')} />}
          </ContactWrapper>
        </Grid>
      </Grid>
    </StyledLandingContainer>
  );
};

export default LandingPage;
